import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const creationTypeFilter = (): FilterDefinition => ({
  label: i18n.t('expenses_v2.forms.fields.creation_type.label'),
  type: 'in',
  options: {
    options: [
      { label: i18n.t('expenses_v2.types.automatic'), value: 'automatic' },
      { label: i18n.t('expenses_v2.types.manual'), value: 'manual' },
    ],
  },
})
